import { useEffect, useMemo, useRef, useState } from 'react';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import {
  Tabs,
  Drawer,
  Button,
  Radio,
  Space,
  RadioChangeEvent,
  DatePicker,
} from 'antd';
import './style.scss';
import { IRootState } from '../../../store/reducers';
import { useHistory, useParams } from 'react-router-dom';
import {
  GamesAction,
  ReduxGamesActionType,
} from '../../../store/modules/games';
import {
  GameEnvRegion,
  IGameEnvModel,
  TaskDrawerType,
} from '../../../model/api-modules/env';
import { fetchEnvList } from '../../../api/game/env';
import { getLocalStorageStudioId } from '../../utils/localstorage';
import {
  EnableType,
  IAPIGameItem,
  IAuditItem,
  StudioRole,
} from '../../../model/api-modules';
import { CreateEnvModal } from './components/create-env-modal';
import { getColumns } from './config/table-config';
import { DeleteEnvModal } from './components/delete-env-modal';
import { TabBasic } from './components/tab-basic';
import { TabEnvs } from './components/tab-envs';
import { TabApi } from './components/tab-api';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from '../../../components/message';
import getFormatMessage from '../../../locales/get-format-message';
import {
  fetchUserPermission,
  PermissionAction,
} from '../../../store/modules/permission';
import { PermissionCheck } from '../../component/permission-check';
import {
  getServiceStatusByEnv,
  cancelTask,
  openService,
  closeService,
  getServiceStatus,
  changeServiceType,
} from '../../../api/services';
import closeIcon from '../../../assets/svg/close-icon.svg';
import warningIcon from '../../../assets/svg/warning-circle-fill.svg';
import arrowRightUpIcon from '../../../assets/svg/arrow-right-up.svg';
import completedIcon from '../../../assets/svg/completed.svg';
import inProgressIcon from '../../../assets/svg/in-progress.svg';
import waitingIcon from '../../../assets/svg/waiting.svg';
import failedIcon from '../../../assets/svg/failed.svg';
import moment, { Moment } from 'moment';
import { ModalWrap } from '../../../components/modal-wrap';
import { CustomPopover } from '../../../components/custom-popover';
import { auditWriteLog } from '../../lib/aduit-log';
import { DeployArea, RbacRoleObjectKey } from '../../../model';
import { getConfig } from '../../../config';
import { getEnvNameByValue } from '../../utils/env';
import { renderEnvTaskStatus } from '../../lib';
import { getLocalTime } from '../../../lib';
import { TabTime } from './components/tab-time';
import { AutoTooltip } from '../../../components/auto-tooltip';
import { isVersionGreaterThan } from '../lib';

export const ConsoleGameInfo = () => {
  const history = useHistory();
  const permissionDispatch = useDispatch<Dispatch<PermissionAction>>();
  const allServiceConfig = useSelector(
    (state: IRootState) => state.games.allServiceConfig
  );
  const games = useSelector((state: IRootState) => state.games.games);
  const [selectedGame, setSelectedGame] = useState<IAPIGameItem>();
  const gamesDispatch = useDispatch<Dispatch<GamesAction>>();
  const [envList, setEnvList] = useState<ReadonlyArray<IGameEnvModel>>([]);
  const allEnvList = useSelector((state: IRootState) => state.games.allEnvList);
  const [selectRow, setSelectRow] = useState<IGameEnvModel | null>(null);
  const [showCreateDrawer, setShowCreateDrawer] = useState<boolean>(false);
  const [showViewPlanDrawer, setShowViewPlanDrawer] = useState<boolean>(false);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [allServiceStatus, setAllServiceStatus] = useState<any[]>([]);
  const [isNeedPoll, setIsNeedPoll] = useState<boolean>(false);
  const [drawerType, setDrawerType] = useState<string>('');
  const [timeType, setTimeType] = useState<number>(0);
  const [openType, setOpenType] = useState<number>(0);
  const [isDateRangeSelected, setIsDateRangeSelected] =
    useState<boolean>(false);
  const [dateRange, setDateRange] = useState<string>('');
  const [showDrawerConfirm, setShowDrawerConfirm] = useState<boolean>(false);
  const [drawerLoading, setDrawerLoading] = useState<boolean>(false);
  const [isHasVersion, setIsHasVersion] = useState<boolean>(false);
  const [privacyAccessOpened, setPrivacyAccessOpened] =
    useState<boolean>(false);
  const [envRow, setEnvRow] = useState<IGameEnvModel | null>(null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const routeParams = useParams<{ gameId: string; envId: string }>();

  const studioId = getLocalStorageStudioId();
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    checkPermission();
  }, [routeParams.gameId, routeParams.envId]);

  // 添加 UTC 时间格式化函数
  const formatUtcDateTime = (timestamp: number): string => {
    return moment.unix(timestamp).utc().format('YYYY-MM-DD HH:mm:ss');
  };

  const parseUtcDateTime = (dateString: string): number => {
    return moment.utc(dateString, 'YYYY-MM-DD HH:mm:ss').unix();
  };

  const getPrivacyAccessStatus = async () => {
    const serviceItem = allServiceConfig?.find(
      (item) => item.Name === 'Privacy Access'
    );
    if (serviceItem && selectRow) {
      const res = await getServiceStatus(
        routeParams.gameId,
        serviceItem.id,
        selectRow.id
      );
      if (res && res.length !== 0) {
        let isPrivacyAccessOpened = false;
        res.forEach((item) => {
          if (item.status === 1 && item.stage === 'opened') {
            isPrivacyAccessOpened = true;
          }
        });
        const closeItem = res.find(
          (item) => item.stage === 'opened' && item.status === 2
        );
        if (closeItem) {
          isPrivacyAccessOpened = false;
        }
        setPrivacyAccessOpened(isPrivacyAccessOpened);
      }
    }
  };

  const safeParse = (data: unknown) => {
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        console.warn('JSON 解析失败', e);
        return {};
      }
    }
    return data;
  };

  const clickEnvItem = (row: IGameEnvModel) => {
    setEnvRow(row);
  };

  const closeEnvDrawer = () => {
    setEnvRow(null);
  };

  const renderEnvDrawerContent = () => {
    if (!envRow) return null;
    const deployArea: DeployArea = getConfig()?.deployArea;
    const isWoa = deployArea === DeployArea.woa;
    const displayText =
      isWoa && envRow.Region === GameEnvRegion.Woa
        ? getFormatMessage('idc_label_type')
        : getEnvNameByValue(envRow.Region);
    const taskInfo = allServiceStatus.find(
      (item) => item?.result[0]?.env_id === envRow.Guid
    )?.result?.[0];
    const gos = JSON.parse(envRow.GosParams || '{}');
    return (
      <div className="env-drawer-box">
        <div className="env-drawer-title">{getFormatMessage('basic')}</div>
        <div className="env-drawer-basic">
          <div className="env-drawer-basic-item">
            <div className="basic-item-title">
              {getFormatMessage('admin_env_type')}
            </div>
            <div className="basic-item-val">{envRow?.Type || ''}</div>
          </div>
          <div className="env-drawer-basic-item">
            <div className="basic-item-title">ID</div>
            <div className="basic-item-val">{envRow?.id || ''}</div>
          </div>
          <div className="env-drawer-basic-item">
            <div className="basic-item-title">
              {getFormatMessage('name_uppercase')}
            </div>
            <div className="basic-item-val">{envRow?.Name || ''}</div>
          </div>
          <div className="env-drawer-basic-item">
            <div className="basic-item-title">{getFormatMessage('region')}</div>
            <div className="basic-item-val">{displayText}</div>
          </div>
          <div className="env-drawer-basic-item">
            <div className="basic-item-title">{getFormatMessage('status')}</div>
            <div className="basic-item-val">
              {renderEnvTaskStatus(taskInfo)}
            </div>
          </div>
          <div className="env-drawer-basic-item">
            <div className="basic-item-title">
              {getFormatMessage('description')}
            </div>
            <AutoTooltip title={envRow?.Description || '--'} placement="bottom">
              <div className="basic-item-val">
                {envRow?.Description || '--'}
              </div>
            </AutoTooltip>
          </div>
          <div className="env-drawer-basic-item">
            <div className="basic-item-title">
              {getFormatMessage('service_version')}
            </div>
            <div className="basic-item-val custom-tooltip-container">
              {gos?.GameServiceVersion || '--'}
            </div>
          </div>
          <div className="env-drawer-basic-item">
            <div className="basic-item-title">
              {getFormatMessage('server_url')}
            </div>
            <div className="basic-item-val">{gos?.BianQueAddr || '--'}</div>
          </div>
          <div className="env-drawer-basic-item">
            <div className="basic-item-title">
              {getFormatMessage('gate_address')}
            </div>
            <div className="basic-item-val">{gos?.GateAddress || '--'}</div>
          </div>
          <div className="env-drawer-basic-item">
            <div className="basic-item-title">
              {getFormatMessage('realm_url')}
            </div>
            <div className="basic-item-val">{gos?.ReamURL || '--'}</div>
          </div>
        </div>
        <div className="env-drawer-title">
          {getFormatMessage('creation_information')}
        </div>
        <div className="env-drawer-crete-item">
          <div className="crete-item-title">
            {getFormatMessage('create_by')}
          </div>
          <div className="crete-item-val">
            {envRow.FounderUid || getFormatMessage('system')}
          </div>
        </div>
        <div className="env-drawer-crete-item">
          <div className="crete-item-title">
            {getFormatMessage('create_time_local')}
          </div>
          <div className="crete-item-val">
            {getLocalTime(envRow.CreateTime, userInfo?.UserSettings?.Timezone)}
          </div>
        </div>
      </div>
    );
  };

  const renderEnvDrawer = () => {
    return (
      <Drawer
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>{getFormatMessage('environment_details')}</div>
            <img
              src={closeIcon}
              className="sync-close-icon"
              onClick={closeEnvDrawer}
            />
          </div>
        }
        placement="right"
        width={720}
        closable={false}
        className="env-drawer"
        onClose={closeEnvDrawer}
        visible={!!envRow}
        headerStyle={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          marginLeft: '3px',
        }}
        footer={
          <Button
            className="gc-btn gc-btn-default sync-cancel"
            style={{ width: '80px', borderRadius: '4px' }}
            onClick={closeEnvDrawer}
          >
            {getFormatMessage('close')}
          </Button>
        }
      >
        {renderEnvDrawerContent()}
      </Drawer>
    );
  };

  useEffect(() => {
    getPrivacyAccessStatus();
    if (
      selectRow &&
      (drawerType === TaskDrawerType.ViewPlan ||
        drawerType === TaskDrawerType.OpenType)
    ) {
      const itemStatus = allServiceStatus.find(
        (item) => item?.result[0]?.env_id === selectRow.Guid
      );
      const task = itemStatus?.result[0]?.task;
      const reqDetail = task?.req_detail
        ? safeParse(itemStatus.result[0].task.req_detail)
        : {};
      let enableType;
      if (drawerType === TaskDrawerType.ViewPlan) {
        enableType = reqDetail?.enable_type || 0;
        const expectedExecutionTime = reqDetail?.expected_execution_time
          ? formatUtcDateTime(reqDetail?.expected_execution_time)
          : '';
        if (expectedExecutionTime) {
          setTimeType(1);
          setDateRange(expectedExecutionTime);
          setIsDateRangeSelected(true);
        }
      } else if (drawerType === TaskDrawerType.OpenType) {
        enableType = itemStatus?.result[0]?.open_status || 0;
      }
      setOpenType(enableType);
    }
  }, [drawerType, selectRow]);

  const checkPermission = async () => {
    if (!routeParams.gameId) {
      return;
    }
    await fetchUserPermission(permissionDispatch)({
      gameID: routeParams.gameId,
      envID: routeParams.envId ? Number(routeParams.envId) : undefined,
    });
  };

  const onShowCreateDrawer = () => {
    setShowCreateDrawer(true);
  };

  const onEdit = (record: IGameEnvModel) => {
    setIsEdit(true);
    // 也打开弹窗
    setSelectRow(record);
    setShowCreateDrawer(true);
  };

  const onShowServiceDrawer = (record: IGameEnvModel, type: string) => {
    setSelectRow(record);
    setShowViewPlanDrawer(true);
    setDrawerType(type);
  };

  const onCloseViewPlan = () => {
    setSelectRow(null);
    setShowViewPlanDrawer(false);
    setTimeType(0);
    setOpenType(0);
    setIsDateRangeSelected(false);
    setDateRange('');
  };

  const onTimeChange = (e: RadioChangeEvent) => {
    setTimeType(e.target.value);
    if (e.target.value === 0) {
      setDateRange('');
      setIsDateRangeSelected(false);
    } else if (e.target.value === 1) {
      // const timeString = moment('23:59:59', 'HH:mm:ss').format(
      //   'YYYY-MM-DD HH:mm:ss'
      // );
      const timeString = moment
        .utc('23:59:59', 'HH:mm:ss')
        .format('YYYY-MM-DD HH:mm:ss');
      setDateRange(timeString);
      setIsDateRangeSelected(true);
    }
  };

  const onOpenTypeChange = (e: RadioChangeEvent) => {
    setOpenType(e.target.value);
  };

  const handleDateChange = (date: any, dateString: string) => {
    const today = moment.utc().format('YYYY-MM-DD HH:mm:ss');
    const selectedDateStr = date.format('YYYY-MM-DD HH:mm:ss');
    if (selectedDateStr < today) {
      return;
    }
    if (!date) {
      setDateRange('');
      setIsDateRangeSelected(false);
    } else {
      setDateRange(dateString);
      setIsDateRangeSelected(true);
    }
  };

  const disabledDate: (current: Moment | null) => boolean = (current) => {
    if (!current) return false;
    const todayUTC = moment.utc().format('YYYY-MM-DD');
    const currentDateUTC = current.format('YYYY-MM-DD');
    return currentDateUTC < todayUTC;
  };
  const disabledDateTime = (current: Moment | null) => {
    if (!current) {
      // 如果没有选中日期，使用当前 UTC 时间作为参考
      const nowUTC = moment.utc();
      return {
        disabledHours: () => Array.from({ length: nowUTC.hour() }, (_, i) => i),
        disabledMinutes: (selectedHour: number) =>
          selectedHour === nowUTC.hour()
            ? Array.from({ length: nowUTC.minute() }, (_, i) => i)
            : [],
        disabledSeconds: (selectedHour: number, selectedMinute: number) =>
          selectedHour === nowUTC.hour() && selectedMinute === nowUTC.minute()
            ? Array.from({ length: nowUTC.second() }, (_, i) => i)
            : [],
      };
    }

    // 根据选中的日期来判断（按 UTC 比较）
    const isTodayUTC = current.isSame(moment.utc(), 'day');

    if (isTodayUTC) {
      // 如果是今天（UTC），禁用当前 UTC 时间之前的时间
      const nowUTC = moment.utc();
      return {
        disabledHours: () => Array.from({ length: nowUTC.hour() }, (_, i) => i),
        disabledMinutes: (selectedHour: number) =>
          selectedHour === nowUTC.hour()
            ? Array.from({ length: nowUTC.minute() }, (_, i) => i)
            : [],
        disabledSeconds: (selectedHour: number, selectedMinute: number) =>
          selectedHour === nowUTC.hour() && selectedMinute === nowUTC.minute()
            ? Array.from({ length: nowUTC.second() }, (_, i) => i)
            : [],
      };
    }

    // 如果不是今天（UTC 今天之后），不禁用任何时间
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
      disabledSeconds: () => [],
    };
  };

  const goBlacklist = () => {
    const serviceItem = allServiceConfig?.find(
      (item) => item.Name === 'Privacy Access'
    );
    if (serviceItem && selectRow) {
      window.open(
        `${location.origin}/console/build/${routeParams.gameId}/${selectRow.id}/${serviceItem.id}`
      );
    }
  };

  const onDeleteRecord = (record: IGameEnvModel) => {
    setModalVisible(true);
    setSelectRow(record);
  };

  const confirmClick = async () => {
    if (!selectRow) {
      return false;
    }
    setShowDrawerConfirm(false);
    setDrawerLoading(true);
    let res;
    let tips = '';
    if (drawerType === TaskDrawerType.ViewPlan) {
      const itemStatus = allServiceStatus.find(
        (item) => item?.result[0]?.env_id === selectRow.Guid
      );
      const task = itemStatus?.result[0]?.task;
      if (task) {
        res = await cancelTask(
          selectRow.GameID,
          selectRow.id,
          selectRow.Guid,
          task.k8s_app_task_id
        );
        tips = `${selectRow.Name} ${getFormatMessage('cancel_task')}(${
          task.k8s_app_task_id
        })`;
      }
    } else if (drawerType === TaskDrawerType.Open) {
      res = await openService(
        selectRow.GameID,
        selectRow.id,
        selectRow.Guid,
        openType,
        timeType === 1 ? parseUtcDateTime(dateRange) : 0
      );
      tips = `${selectRow.Name} ${getFormatMessage('service_open_task')}`;
    } else if (drawerType === TaskDrawerType.OpenType) {
      res = await changeServiceType(
        selectRow.GameID,
        selectRow.id,
        selectRow.Guid,
        openType,
        timeType === 1 ? parseUtcDateTime(dateRange) : 0
      );
      tips = `${selectRow.Name} ${getFormatMessage('service_open_task')}`;
      auditWriteLog(IAuditItem.ChooseOpenType, {
        gameID: selectRow.GameID,
        envID: selectRow.Guid,
        envType: selectRow.Type,
        detail: {
          gameID: selectRow.GameID,
          envID: selectRow.Guid,
          envType: selectRow.Type,
          enable_type: openType,
          expected_execution_time:
            timeType === 1 ? parseUtcDateTime(dateRange) : 0,
        },
      });
    } else if (drawerType === TaskDrawerType.Close) {
      res = await closeService(
        selectRow.GameID,
        selectRow.id,
        selectRow.Guid,
        timeType === 1 ? parseUtcDateTime(dateRange) : 0
      );
      tips = `${selectRow.Name} ${getFormatMessage('service_close_task')}`;
      auditWriteLog(IAuditItem.CloseGameEnvironment, {
        gameID: selectRow.GameID,
        envID: selectRow.Guid,
        envType: selectRow.Type,
        detail: {
          gameID: selectRow.GameID,
          envID: selectRow.Guid,
          envType: selectRow.Type,
          expected_execution_time:
            timeType === 1 ? parseUtcDateTime(dateRange) : 0,
        },
      });
    }
    setDrawerLoading(false);
    if (res === 0) {
      messageSuccess(`${tips} ${getFormatMessage('success')}`);
      onCloseViewPlan();
      getEnvList(false);
      return true;
    }
    if (res === 10021) {
      messageError(getFormatMessage('task_cannot_cancel'));
      return false;
    }
    messageError(`${tips} ${getFormatMessage('failed')}`);
    return false;
  };

  const renderDrawerTitle = () => {
    let title = '';
    if (drawerType === TaskDrawerType.ViewPlan) {
      const itemStatus = allServiceStatus.find(
        (item) => item?.result[0]?.env_id === selectRow?.Guid
      );
      const task = itemStatus?.result[0]?.task;
      title = getFormatMessage('view_task');
      if (task?.k8s_app_task_type === 527) {
        title = getFormatMessage('view_shutdown_task');
      } else if (
        task?.k8s_app_task_type === 526 ||
        task?.k8s_app_task_type === 529
      ) {
        title = getFormatMessage('view_opening_task');
      }
    } else if (drawerType === TaskDrawerType.OpenType) {
      title = getFormatMessage('switch_open_type');
    } else if (drawerType === TaskDrawerType.Open) {
      title = `${getFormatMessage('service_open')} ${selectRow?.Name || ''}`;
    } else if (drawerType === TaskDrawerType.Close) {
      title = `${getFormatMessage('service_close')} ${selectRow?.Name || ''}`;
    }
    return title;
  };

  const footer = () => {
    let enableType;
    const itemStatus = allServiceStatus.find(
      (item) => item?.result[0]?.env_id === selectRow?.Guid
    );
    const task = itemStatus?.result[0]?.task;
    if (drawerType === TaskDrawerType.OpenType) {
      enableType = itemStatus?.result[0]?.open_status;
    }
    return (
      <div>
        <Button
          className="gc-btn gc-btn-default sync-cancel"
          style={{ width: '80px', borderRadius: '4px' }}
          onClick={onCloseViewPlan}
        >
          {getFormatMessage('cancel')}
        </Button>
        {enableType === openType ? (
          <CustomPopover content={getFormatMessage('no_change_disabled')}>
            <div className="drawer-disabed-btn" style={{ minWidth: '80px' }}>
              <span>
                {drawerType === TaskDrawerType.ViewPlan
                  ? getFormatMessage('cancel_task')
                  : getFormatMessage('submit')}
              </span>
            </div>
          </CustomPopover>
        ) : (
          <Button
            className="gc-btn gc-btn-primary"
            onClick={() => setShowDrawerConfirm(true)}
            style={{ minWidth: '80px', borderRadius: '4px' }}
            loading={drawerLoading}
            disabled={
              (timeType === 1 && !isDateRangeSelected) ||
              (drawerType === TaskDrawerType.ViewPlan && task?.status !== 0)
            }
          >
            {drawerType === TaskDrawerType.ViewPlan
              ? getFormatMessage('cancel_task')
              : getFormatMessage('submit')}
          </Button>
        )}
      </div>
    );
  };

  const isShowOpenType = () => {
    let isShow = true;
    if (drawerType === TaskDrawerType.Close) {
      isShow = false;
    }
    if (drawerType === TaskDrawerType.ViewPlan) {
      const itemStatus = allServiceStatus.find(
        (item) => item?.result[0]?.env_id === selectRow?.Guid
      );
      const task = itemStatus?.result[0]?.task;
      if (task?.k8s_app_task_type === 527) {
        isShow = false;
      }
    }
    return isShow;
  };

  const renderDrawerContent = () => {
    let title = '';
    let timeTitle = '';
    let taskStatus = '';
    let taskStatusIcon = '';
    let taskStatusColor = '';
    if (drawerType === TaskDrawerType.ViewPlan) {
      const itemStatus = allServiceStatus.find(
        (item) => item?.result[0]?.env_id === selectRow?.Guid
      );
      if (itemStatus) {
        const task = itemStatus.result[0]?.task;
        if (task?.k8s_app_task_type === 527) {
          timeTitle = getFormatMessage('close_time');
        } else if (task?.k8s_app_task_type === 526) {
          timeTitle = getFormatMessage('open_time');
        }
        if (task?.status === 0) {
          taskStatus = 'Waiting';
          taskStatusIcon = waitingIcon;
          taskStatusColor = '#86909C';
        } else if (task?.status === 1) {
          taskStatus = 'In Progress';
          taskStatusIcon = inProgressIcon;
          taskStatusColor = '#5764F1';
        } else if (task?.status === 2) {
          taskStatus = 'Completed';
          taskStatusIcon = completedIcon;
          taskStatusColor = '#3EC688';
        } else if (
          task?.status === 3 ||
          task?.status === 4 ||
          task?.status === 5
        ) {
          taskStatus = 'Failed';
          taskStatusIcon = failedIcon;
          taskStatusColor = '#F54E4E';
        } else {
          taskStatus = 'Completed';
          taskStatusIcon = completedIcon;
          taskStatusColor = '#3EC688';
        }
      }
    } else if (drawerType === TaskDrawerType.Open) {
      title = getFormatMessage('drawer_open_tips');
      timeTitle = getFormatMessage('open_time');
    } else if (drawerType === TaskDrawerType.Close) {
      title = getFormatMessage('drawer_close_tips');
      timeTitle = getFormatMessage('close_time');
    } else if (drawerType === TaskDrawerType.OpenType) {
      title = getFormatMessage('drawer_open_type_tips');
      timeTitle = getFormatMessage('open_time');
    }
    return (
      <div>
        {title && (
          <div className="drawer-tips">
            <img
              src={warningIcon}
              style={{
                display: 'inline-block',
                width: 14,
                height: 14,
                marginRight: 8,
              }}
            />
            <span>{title}</span>
          </div>
        )}
        {drawerType === TaskDrawerType.ViewPlan && (
          <div className="drawer-item-box">
            <div className="drawer-item-title">
              {getFormatMessage('task_status')}
            </div>
            <div className="drawer-item-content">
              <img
                src={taskStatusIcon}
                style={{
                  display: 'inline-block',
                  width: 14,
                  height: 14,
                  marginRight: 8,
                  marginTop: -2,
                }}
                className={
                  taskStatusIcon === inProgressIcon ? 'drawer-item-rotate' : ''
                }
              />
              <span style={{ color: taskStatusColor }}>{taskStatus}</span>
            </div>
          </div>
        )}
        <div className="drawer-item-box">
          <div className="drawer-item-title">
            {getFormatMessage('drawer_env_info')}
          </div>
          <div className="drawer-item-content">{`${selectRow?.Name || ''}(${
            selectRow?.id || ''
          })`}</div>
        </div>
        <div className="drawer-item-box">
          <div className="drawer-item-title">{timeTitle}</div>
          <div>
            <Radio.Group
              onChange={onTimeChange}
              value={timeType}
              disabled={drawerType === TaskDrawerType.ViewPlan}
            >
              <Space direction="vertical">
                <Radio value={0}>{getFormatMessage('time_instant')}</Radio>
                <Radio value={1}>{getFormatMessage('time_scheduled')}</Radio>
              </Space>
            </Radio.Group>
          </div>
          {timeType === 1 && (
            <div style={{ marginTop: 8 }}>
              <DatePicker
                format="YYYY-MM-DD HH:mm:ss"
                value={
                  dateRange
                    ? moment.utc(dateRange, 'YYYY-MM-DD HH:mm:ss')
                    : moment.utc('23:59:59', 'HH:mm:ss')
                }
                onChange={handleDateChange}
                disabledDate={disabledDate}
                disabledTime={disabledDateTime}
                showTime={{ format: 'HH:mm:ss' }}
                defaultValue={
                  dateRange
                    ? moment.utc(dateRange, 'YYYY-MM-DD HH:mm:ss')
                    : moment.utc('23:59:59', 'HH:mm:ss')
                }
                disabled={drawerType === TaskDrawerType.ViewPlan}
              />
            </div>
          )}
        </div>
        {isShowOpenType() && (
          <div className="drawer-item-box">
            <div className="drawer-item-title">
              {getFormatMessage('open_type')}
            </div>
            <div>
              <Radio.Group
                onChange={onOpenTypeChange}
                value={openType}
                disabled={drawerType === TaskDrawerType.ViewPlan}
              >
                <Space direction="vertical">
                  <Radio value={EnableType.OpenFull}>
                    {getFormatMessage('full_public_access')}
                  </Radio>
                  {privacyAccessOpened ? (
                    <Radio value={EnableType.PrivacyWhitelist}>
                      <div style={{ display: 'flex' }}>
                        <span>{getFormatMessage('whitelist_access')}</span>
                        {openType === 1 && (
                          <span
                            style={{
                              display: 'flex',
                              color: '#5764F1',
                              fontSize: 12,
                              marginLeft: 16,
                              marginTop: 4,
                              cursor: 'pointer',
                              fontWeight: 400,
                            }}
                            onClick={() => goBlacklist()}
                          >
                            <span>{getFormatMessage('view_whitelist')}</span>
                            <img
                              src={arrowRightUpIcon}
                              style={{
                                width: 12,
                                height: 12,
                                marginLeft: 2,
                                marginTop: 3,
                              }}
                            />
                          </span>
                        )}
                      </div>
                    </Radio>
                  ) : (
                    <CustomPopover
                      content={getFormatMessage('not_privacy_access')}
                    >
                      <Radio
                        value={EnableType.PrivacyWhitelist}
                        disabled={true}
                      >
                        {getFormatMessage('whitelist_access')}
                      </Radio>
                    </CustomPopover>
                  )}
                  {/* <Radio value={EnableType.IPWhitelist}>{getFormatMessage('gro_restriction')}</Radio> */}
                </Space>
              </Radio.Group>
            </div>
          </div>
        )}
      </div>
    );
  };

  const getEnvList = async (isDeletedEnv: boolean, deleteEnvId?: number) => {
    if (routeParams.gameId) {
      setLoading(true);
      const res = await fetchEnvList(routeParams.gameId);
      if (res) {
        setEnvList(res);
        gamesDispatch({
          type: ReduxGamesActionType.SET_ALL_ENVS,
          result: res,
        });
        // 判断删除环境后有无环境存在
        if (isDeletedEnv && res.length === 0) {
          messageWarning(getFormatMessage('game_no_env_choose_again'));
          history.push(`/studio/${studioId}/portal`);
        } else if (
          isDeletedEnv &&
          deleteEnvId &&
          deleteEnvId.toString() === routeParams.envId
        ) {
          // 如果删除的是当前选中的环境且删除后还有环境存在，则跳转到第一个有效环境
          const envItem = res.find((item) => item.id !== deleteEnvId);
          if (envItem?.id) {
            history.push(
              `/console/game-info/${routeParams.gameId}/${envItem.id}`
            );
          }
        }
      }
      setLoading(false);
    }
  };

  // 游戏工作室Owner，Admin可以删除游戏，游戏的creator不特殊处理
  const hasPermission = useMemo(() => {
    return (
      !!selectedGame?.userStudioRoleID &&
      !![StudioRole.Owner, StudioRole.Admin].includes(
        selectedGame.userStudioRoleID
      )
    );
  }, [selectedGame]);

  const getServiceItemStatus = async (
    gameId: string,
    envId: number,
    envGuid: string
  ) => {
    return await getServiceStatusByEnv(gameId, envId, envGuid);
  };

  const activeRequestRef = useRef<symbol | null>(null);

  const queryServiceStatus = async () => {
    const requestId = Symbol(); // 生成唯一标识
    activeRequestRef.current = requestId;
    try {
      const results = await Promise.all(
        envList.map((item) =>
          getServiceItemStatus(item.GameID, item.id, item.Guid)
        )
      );
      if (activeRequestRef.current !== requestId) {
        return null;
      }
      return results;
    } catch (error) {
      console.error('errpr:', error);
      throw error;
    }
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (
      isNeedPoll &&
      (!showViewPlanDrawer ||
        (showViewPlanDrawer && drawerType === TaskDrawerType.ViewPlan))
    ) {
      // 设置6秒的轮询间隔
      timerRef.current = setInterval(() => {
        getAllServiceStatus();
      }, 6000);
    } else {
      // 清除定时器
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    }
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isNeedPoll, showViewPlanDrawer, drawerType]);

  const getAllServiceStatus = () => {
    queryServiceStatus().then((finalResults) => {
      console.log('finalResults:', finalResults);
      let needPoll = false;
      if (finalResults && finalResults.length !== 0) {
        finalResults.forEach((resultItem) => {
          if (resultItem?.result[0]?.task?.k8s_app_task_id) {
            needPoll = true;
          }
        });
      }
      if (!finalResults) {
        return;
      }
      setIsNeedPoll(needPoll);
      setAllServiceStatus(finalResults);
    });
  };

  const renderDrawerConfirmModal = () => {
    if (showDrawerConfirm) {
      let title = '';
      let desc = '';
      if (drawerType === TaskDrawerType.ViewPlan) {
        title = getFormatMessage('cancellation_confirmation');
        desc = getFormatMessage('cancellation_confirmation_tips');
      } else if (drawerType === TaskDrawerType.Close) {
        title = getFormatMessage('close_confirmation');
        desc = getFormatMessage('close_confirmation_tips');
      } else {
        title = getFormatMessage('open_confirmation');
        desc = getFormatMessage('open_confirmation_tips');
      }
      return (
        <ModalWrap
          width="434px"
          onClose={() => setShowDrawerConfirm(false)}
          title={title}
          oKText={getFormatMessage('confirm')}
          cancelText={getFormatMessage('cancel')}
          onOk={confirmClick}
          // className="fail-dialog"
        >
          <div>{desc}</div>
        </ModalWrap>
      );
    }
    return null;
  };

  useEffect(() => {
    if (games.length) {
      setSelectedGame(games.find((item) => item.gameID === routeParams.gameId));
    }
  }, [routeParams, games]);

  useEffect(() => {
    getAllServiceStatus();

    let hasVersion = false;
    envList.forEach((item) => {
      const gos = JSON.parse(item.GosParams || '{}');
      if (gos?.GameServiceVersion) {
        hasVersion = true;
      }
    });
    setIsHasVersion(hasVersion);
  }, [envList]);

  useEffect(() => {
    getEnvList(false);
  }, [routeParams.gameId, routeParams.envId, allEnvList]);

  const renderTabs = () => {
    const tabs = [
      {
        key: '0',
        label: getFormatMessage('basic'),
        children: (
          <TabBasic
            selectedGame={selectedGame}
            hasPermission={hasPermission}
            studioID={studioId}
          />
        ),
      },
      {
        key: '2',
        label: getFormatMessage('env_length', {
          params: {
            envListLength: envList.length,
          },
        }),
        children: (
          <TabEnvs
            selectedGame={selectedGame}
            loading={loading}
            envList={envList}
            gameID={selectedGame?.gameID}
            columns={getColumns(
              onEdit,
              onDeleteRecord,
              onShowServiceDrawer,
              clickEnvItem,
              allServiceStatus,
              isHasVersion,
              userInfo
            )}
            allServiceConfig={allServiceConfig}
            onShowCreateDrawer={onShowCreateDrawer}
            onDeleteRecord={onDeleteRecord}
            envID={routeParams.envId}
          />
        ),
      },
      {
        key: '3',
        label: getFormatMessage('client_api_control'),
        children: (
          <PermissionCheck
            contentType="page"
            permissionKey={RbacRoleObjectKey.ClientAPIControlView}
          >
            <TabApi
              allServiceConfig={allServiceConfig}
              envList={envList}
              gameID={selectedGame?.gameID}
              envID={routeParams.envId}
              onShowCreateDrawer={onShowCreateDrawer}
              studioId={studioId}
            />
          </PermissionCheck>
        ),
      },
    ];
    let hasThanVerison = false;
    envList.forEach((item) => {
      const gos = JSON.parse(item?.GosParams || '{}');
      if (isVersionGreaterThan(gos?.GameServiceVersion, '1.13.0')) {
        hasThanVerison = true;
      }
    });
    // 有超过1.13.0版本环境的游戏才显示系统设置
    if (hasThanVerison) {
      tabs.push({
        key: '4',
        label: getFormatMessage('system_settings'),
        children: <TabTime selectedGame={selectedGame} envList={envList} />,
      });
    }
    return (
      <div>
        <Tabs
          className="game-tab"
          defaultActiveKey={urlParams.get('activeKey') || '0'}
          items={tabs}
        ></Tabs>
      </div>
    );
  };

  return (
    <PermissionCheck gameID={routeParams.gameId} contentType="page">
      <div className="game-info-box">
        <div className="gc-setting">
          <div className="setting-content">{renderTabs()}</div>
        </div>
        {modalVisible ? (
          <DeleteEnvModal
            allServiceConfig={allServiceConfig}
            refresh={() => getEnvList(true, selectRow?.id)}
            studioId={studioId}
            selectedGame={selectedGame}
            selectRow={selectRow}
            onClose={() => setModalVisible(false)}
          />
        ) : null}

        <CreateEnvModal
          isEdit={isEdit}
          selectRow={selectRow}
          isShow={showCreateDrawer}
          onClose={() => {
            setShowCreateDrawer(false);
            setIsEdit(false);
            setSelectRow(null);
          }}
          refresh={() => getEnvList(false)}
          selectedGame={selectedGame}
        />
        <Drawer
          title={
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>{renderDrawerTitle()}</div>
              <img
                src={closeIcon}
                className="sync-close-icon"
                onClick={onCloseViewPlan}
              />
            </div>
          }
          placement="right"
          width={720}
          closable={false}
          className="service-drawer"
          onClose={onCloseViewPlan}
          visible={showViewPlanDrawer}
          headerStyle={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
            marginLeft: '3px',
          }}
          footer={footer()}
        >
          {renderDrawerContent()}
        </Drawer>
        {renderDrawerConfirmModal()}
        {renderEnvDrawer()}
      </div>
    </PermissionCheck>
  );
};
